module.exports = __webpack_public_path__ + "img/6-2.b06f0806.png";